import React from 'react';
import styles from '../price-details.module.css';

interface PriceSectionProps {
  icon: React.ReactNode;
  title: string;
  testId?: string;
  children: React.ReactNode;
}

/** A bordered "Vehicle price" / "Your selections" / "Trade-in" block with a 16px icon heading. */
const PriceSection = ({ icon, title, testId, children }: PriceSectionProps) => (
  <section className={styles.section} data-testid={testId}>
    <div className={styles.sectionHeading}>
      <span className={styles.sectionIcon} aria-hidden>
        {icon}
      </span>
      <h3 className={styles.sectionTitle}>{title}</h3>
    </div>
    <div className={styles.sectionBody}>{children}</div>
  </section>
);

export default PriceSection;
